import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ListarPerguntasFrequentesState } from '../reducers/perguntas-frequentes.reducer';

export const selectListarPerguntasFrequentesState = createFeatureSelector<ListarPerguntasFrequentesState>('listarPerguntasFrequentes');

export const selectDadosListarPerguntasFrequentes = createSelector(
  selectListarPerguntasFrequentesState,
  (state: ListarPerguntasFrequentesState) => state.response
);

export const selectListarPerguntasFrequentes = createSelector(
  selectListarPerguntasFrequentesState,
  (state: ListarPerguntasFrequentesState) => state
);

export const selectErrosListarPerguntasFrequentes = createSelector(
  selectListarPerguntasFrequentesState,
  (state: ListarPerguntasFrequentesState) => state.error
);
